import qs from 'qs';
import request from '@/config/request';

/*
  获取咨询列表
  informationTitle
*/
export function getInformationList({ page, pageSize, ...rest }) {
  return request({
    url: `/information/getInformationList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  添加咨询
  informationTitle, informationUrl，informationContent
*/
export function addInformation(rest) {
  return request({
    url: '/information/addInformation',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  删除咨询
  id
*/
export function deleteInformation(id) {
  return request({
    url: '/information/deleteInformation',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取咨询详情
  id
*/
export function getInformation(id) {
  return request({
    url: '/information/getInformation',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑咨询
  id,informationTitle, informationUrl,informationContent
*/
export function updateInformation(rest) {
  return request({
    url: '/information/updateInformation',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  上下架
  id
*/
export function updateInformationUpAndDown(id) {
  return request({
    url: '/information/updateInformationUpAndDown',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}
